<div class="quick-scan-card">
  <artemis-loading-spinner *ngIf="isLoading">
  </artemis-loading-spinner>
  <div ubi-curve-header xlarge class="quick-scan-card__header">
    <div class="quick-scan-card__header-text">
      {{ 'quick_scan.header' | translate }}
    </div>
  </div>
  <artemis-popover>
    <ng-container *ngFor="let section of ('quick_scan.info.content' | translate)">
      <ng-container *ngFor="let content of section.paragraph">
        <p>{{ content }}</p>
      </ng-container>
    </ng-container>
  </artemis-popover>
  <div class="quick-scan-card__content">
    <div class="quick-scan-card__customer-type-pickers">
      <artemis-button-toggle [(ngModel)]="selectedCustomerType">
        <artemis-button-toggle-item *ngFor="let customerType of customerTypes" [value]="customerType">
          {{customerType}}
        </artemis-button-toggle-item>
      </artemis-button-toggle>
    </div>
    <artemis-engines-option (selectedEngines)="setSelectedEngines($event)"></artemis-engines-option>
    <mat-form-field class="custom-mat-form-field quick-scan-card__name-input">
      <input matInput [(ngModel)]="name" type="name" placeholder="{{ 'quick_scan.form.label' | translate }}" required>
    </mat-form-field>
    <div class="quick-scan-card__action-buttons-container">
      <button type="submit" mat-button class="btn_rounded" ubi-round-button (click)="checkBalance()"
              [disabled]="!selectedCustomerType || !name || isLoading || !selectedEngines">
        {{ 'quick_scan.button.quick_scan' | translate }}
      </button>
      <ng-content select="[action-element]">
      </ng-content>
    </div>
  </div>
</div>
